import React, { PropTypes } from 'react';
import { equals, or } from 'ramda';

const GenericRadioButtons = props => {
  const {
    title,
    radiosMap,
    name,
    defaultChecked,
    handleOnClick,
  } = props;

  return (
    <div>
      {
        title ? <p style={{ fontSize: '18px', color: 'rgba(0, 0, 0, 0.87)', fontWeight: '600', marginTop: '5%', textAlign: 'left' }}>{title}</p>
          : <span/>
      }
      {
        radiosMap.map((radio, i) => {
          return (
            <div key={i} style={{ border: '1px solid #eeeeee', height: '68px', textAlign: 'left', padding: '25px 20px 25px 10px' }}>
              <input
                type="radio"
                name={name}
                value={or(radio.value, radio.label)}
                style={{ marginLeft: '20px', float: 'left' }}
                defaultChecked={equals(or(radio.value, radio.label), defaultChecked)}
                onClick={() => handleOnClick(or(radio.value, radio.label))}
                id={or(radio.value, radio.label)}
              />
              <label htmlFor={or(radio.value, radio.label)} style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.87)', marginLeft: '50px', display: 'block', lineHeight: '0.9' }}>
                {radio.label}
              </label>
            </div>
          );
        })
      }
    </div>
  );
};

GenericRadioButtons.propTypes = {
  title: PropTypes.string,
  radiosMap: PropTypes.array,
  name: PropTypes.string,
  handleOnClick: PropTypes.func,
  defaultChecked: PropTypes.string,
};

export default GenericRadioButtons;



// WEBPACK FOOTER //
// ./src/app/components/signup/supplier/generic-radio-buttons.jsx